import { IMG, LINKS } from "../../data/site";
import { scrollToId } from "../../lib/img";
import { CTA, Eyebrow, Photo, Reveal } from "./primitives";
import LocationAccordion from "./LocationAccordion";
import { CLASS_TIMEZONE } from "../../data/classLocations";

export default function Classes() {
  return (
    <section id="classes" aria-labelledby="classes-title" data-testid="classes-section" className="scroll-mt-24 bg-ivory px-6 py-24 sm:px-8 lg:px-12 lg:py-36">
      <div className="mx-auto grid max-w-7xl items-start gap-16 lg:grid-cols-12 lg:gap-16">
        <div className="relative pb-16 lg:sticky lg:top-28 lg:col-span-6 lg:pb-20">
          <Reveal y={40} className="overflow-hidden rounded-[2rem]">
            <div className="aspect-[4/3] overflow-hidden">
              <Photo img={IMG.outdoorGroup} sizes="(min-width:1024px) 45vw, 92vw" className="h-full w-full object-cover transition-transform duration-[1400ms] hover:scale-[1.03]" data-testid="classes-image-outdoor" />
            </div>
          </Reveal>
          <Reveal delay={0.2} y={50} className="absolute -bottom-2 right-0 w-[46%] max-w-[260px] overflow-hidden rounded-[1.5rem] border-[6px] border-ivory shadow-[0_30px_60px_-30px_rgba(43,38,32,0.5)] sm:right-6">
            <div className="aspect-square">
              <Photo img={IMG.indoorGroup} sizes="260px" className="h-full w-full object-cover" data-testid="classes-image-indoor" />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:pl-6">
          <Reveal>
            <Eyebrow>Group classes</Eyebrow>
            <h2 id="classes-title" className="mt-5 font-display text-[2.4rem] font-light leading-[1.05] text-ink sm:text-5xl lg:text-6xl">
              Practice in person or from anywhere.
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-ink-soft sm:text-lg">
              Yoga, breathwork, meditation and mindfulness movement to help you get out of your head and back into your body.
            </p>
          </Reveal>

          <Reveal delay={0.1} className="mt-10">
            <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-ink-soft">Find Jake in person at</p>
            <LocationAccordion />
            <p className="mt-5 text-sm text-ink-soft">Select a studio for its schedule and address. All times {CLASS_TIMEZONE}.</p>
          </Reveal>

          <Reveal delay={0.2} className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-6">
            <CTA href={LINKS.classes} testid="classes-view-button">
              View Classes
            </CTA>
            <CTA href="/classes#this-week" variant="outline" testid="classes-this-week-button">
              View This Week's Classes
            </CTA>
            <a
              href="#online"
              onClick={(e) => {
                e.preventDefault();
                scrollToId("online");
              }}
              data-testid="classes-practice-online-link"
              className="inline-flex min-h-[44px] items-center text-sm font-semibold text-ink underline decoration-coral-ink decoration-1 underline-offset-[6px] transition-colors hover:text-coral-ink"
            >
              Or practice online, anytime
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
